import {Component} from "react"
import Navbar from "react-bootstrap/Navbar"
import Container from "react-bootstrap/Container"
import Nav from "react-bootstrap/Nav"
import {Button} from "react-bootstrap"
import logo from 'images/logo-people.png'
import Image from "react-graceful-image"

export default class JobNavBar extends Component {
  render() {
    return(
      <Navbar bg="#FFFFFF" expand="lg" className="shadow mb-4" style={{zIndex: 1}}>
        <Container style={{maxWidth: '100%'}}>
          <Navbar.Brand href="#/root">
            <Image src={logo} style={{width: 38, height: 38, borderRadius: 3 }} alt="Product Logo"
                   className="d-inline-block align-top"/>
          </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-between">
            <Nav.Link href="#/positions" className="font-weight-bolder awesome-nav">
              Positions
            </Nav.Link>
            <div className="align-self-end">
              <Button variant="secondary" size="sm" style={{borderRadius: 5}} href={'/users/sign_out'}>Logout</Button>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    )
  }
}
